module.exports = __webpack_public_path__ + "bi-analysis-main-page.svg?5c4f3ab97954f480e0bbeab9eae50efa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bi-analysis-main-page.svg
// module id = 280
// module chunks = 2